<!-- Button -->
<div mat-icon-button class="w-full text-left">
    <span class="relative">
        <span class="flex flex-row leading-none">
            <span class="mt-1.5 text-md font-bold">
                {{ username() }}
            </span>
            <button type="button" (click)="signOut()" matTooltip="Sign out">
                <mat-icon
                    class="ml-5"
                    [svgIcon]="
                        'heroicons_outline:arrow-right-on-rectangle'
                    "></mat-icon>
            </button>
        </span>
    </span>
</div>
